<div class="w-full flex flex-col gap-4 p-4 sm:max-w-200 mx-auto">
    <div
        class="w-full flex sm:flex-row flex-col items-center justify-between gap-4"
    >
        <h1 class="text-2xl font-bold">Lista de Holdings</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <p-table
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="lista.length"
        [value]="lista"
        [lazy]="false"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[90%] min-w-30">Nome</th>
                <th class="w-[10%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.NOME }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
